import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import usePortalAuth from '../../../auth/usePortalAuth';
import LoginRedirect from '../../Login/LoginRedirect';

const AdminRoute = ({ component: Component, render: renderProp, path, location, accessLevel, ...rest }) => {
  const { isLoading, isAuthenticated } = usePortalAuth();


  const checkAccessLevel = (accessLevel) => {
    if (accessLevel === 'CompanyAdmin') {
      return true;
    } else if (accessLevel === 'AccountAdmin') {
      return true;
    } else {
      return false;
    }
  };

  const render = (props) => {
    if (isLoading) {
      return null;
    }
    if (isAuthenticated !== true) {
      return <LoginRedirect history={props.history} />;
    }

    if (!checkAccessLevel(accessLevel)) {
      return <Redirect to="/Dashboard/History" />;
    }
    // Prefer `render` prop over `component` so inline render functions don't
    // cause a remount of the subtree on every parent re-render.
    if (typeof renderProp === 'function') {
      return renderProp(props);
    }
    return <Component {...props} />;
  };

  return (
    <Route
      path={path}
      render={(props) => render(props)}
      {...rest}
    />
  );
};

export default AdminRoute;
